import { render, staticRenderFns } from "./PatentCardList.vue?vue&type=template&id=35b5e548"
import script from "./PatentCardList.vue?vue&type=script&lang=js"
export * from "./PatentCardList.vue?vue&type=script&lang=js"
import style0 from "./PatentCardList.vue?vue&type=style&index=0&id=35b5e548&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports